import { createApp } from 'vue/dist/vue.esm-bundler.js'
{
  const appConfig = {
    data(){
      return {
        // localized data
        nominees: [], 

        // state data
        loading: true,
        popupShowing: false,
        tempMessage: "",

        // user data:
        search: '',
        editingAttendee: null,
      }
    },
    mounted(){
      this.nominees = window?.availableNominees || []
      this.loading = false
    },
    computed: {
      filteredNominees(){
        return !this.search.length ? this.nominees : this.nominees.filter(n => {
          const search = this.search.toLowerCase().trim()
          const firstName = n.first_name.toLowerCase().trim()
          const lastName = n.last_name.toLowerCase().trim()
          return `${firstName} ${lastName}`.indexOf(search) != -1
        })
      }
    },
    methods: {
      toggleNomnieeDetails(index){
        if(this.$refs.nomineeDetails[index].style.display == "none"){
          this.$refs.nomineeDetails[index].style.display = ""
        } else {
          this.$refs.nomineeDetails[index].style.display = "none"
        }
      },
      setEditAttendee(attendee){
        this.editingAttendee = JSON.parse(JSON.stringify(attendee))
        this.popupShowing = true
      },
      confirmEdit(){
        this.loading = true
        jQuery.ajax({
          url: coolfse.ajaxUrl, // Localized variable
          method: 'POST',
          data: {
            action: 'confirm_rose_award_attendance',
            attendee: this.editingAttendee
          },
          complete: data => {
            this.loading = false
            this.popupShowing = false

            if(data.status == 200){
              if(data?.responseJSON?.success){
                // success
                this.search = ''
                this.nominees = this.nominees.map(n => {
                  if(n.id == this.editingAttendee.id){
                    n = JSON.parse(JSON.stringify(this.editingAttendee))
                  }
                  return n
                })
                this.flashMessage("Confirmed, thank you!")
              } else {
                // 200 failure (unexpected response)
                this.flashMessage("Invalid response. Something went wrong please try again.")
              }
            } else {
              // unhandled failure (no response)
              this.flashMessage("No response. Something went wrong please try again.")
            }
          }
        })
      },
      flashMessage(msg){
        this.tempMessage = msg
        setTimeout(() => this.tempMessage = "", 5000)
      }
    }
  }

  function initApp(){
    const els = document.querySelectorAll('.photo-checkin-app')
    if(els.length){
      els.forEach(el => {
        const app = createApp(appConfig)
        app.mount(el)
      })
    }
  }

  initApp()
}